import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';
import { RootState } from '../app/store';
import { AnswerModel, SecretaryTasksAndQuestionsModel } from '../models';

export interface ReceptionistState {
  hasStartedReceptionist: boolean;
  tasksAndQuestions?: SecretaryTasksAndQuestionsModel;
  answers: AnswerModel[];
}

const initialState: ReceptionistState = {
  hasStartedReceptionist: false,
  answers: [],
  tasksAndQuestions: undefined
};

export const receptionistSlice = createSlice({
  name: 'receptionist',
  initialState,
  reducers: {
    startReceptionist: (state) => {
      state.hasStartedReceptionist = true;
      return state;
    },
    setTasksAndQuestions: (state, action: PayloadAction<SecretaryTasksAndQuestionsModel>) => {
      state.tasksAndQuestions = action.payload;
      return state;
    },
    setAnswers: (state, action: PayloadAction<AnswerModel[]>) => {
      state.answers = action.payload;
    },
    setLogoutReceptionist: (state) => {
      state = initialState;
      return state;
    },
  },
});

export const { startReceptionist, setTasksAndQuestions, setAnswers, setLogoutReceptionist } = receptionistSlice.actions;

export const selectHasSetupReceptionist = (state: RootState) => {
  // const questions = state.receptionist.tasksAndQuestions?.questions;
  // const answers = state.receptionist.answers;

  // if (!questions || !answers) return false;

  // return questions.every(question =>
  //   answers.some(answer => answer.questionId === question.questionId && answer.answerId > 0)
  // );

  return true;
};

export const selectHasCompletedSetup = (state: RootState) => {
  //return state.business.businessHours.length > 0 && state.numbers.data.rawData.length > 0;
  return true;
};

export const updateAnswer = (questionId: number, answerText: string, businessId: number): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch, getState) => {
    const prevAnswers = getState().receptionist.answers;
    const answer = prevAnswers.find((item: AnswerModel) => item.questionId === questionId);

    const newAnswers = answer ?
                          prevAnswers.map((item: AnswerModel) => item.questionId === questionId ? { ...item, answerText } : item) :
                          [...prevAnswers, { answerId: 0, businessId, questionId, answerText }];

    dispatch(setAnswers(newAnswers));
  };
};

export default receptionistSlice.reducer;
